import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import LeadsHeader from '../components/leads/RoleHeader'
import RolesTable from '../components/leads/RoleTable'
import Footer from '../components/shared/Footer'

const RolesList = () => {
    return (
        <>
            <PageHeader>
                <LeadsHeader />
            </PageHeader>
            <div className='main-content'>
                <div className='row'>
                    <RolesTable />
                </div>
            </div>
            
        </>
    )
}

export default RolesList